import React from 'react';
import { InputContainer, withMobile } from 'components/common';

const SettingsInputContainer = ({
  mobileContext: { isMobile }, children, className, style,
}) => {
  const mobileStyles = isMobile
    ? {
      border: 'none', boxShadow: '0 2px 4px 0 rgba(30, 61, 63, .06)', paddingTop: 16, paddingBottom: 16,
    }
    : {};
  return (
    <InputContainer className={`bg-white ${className}`} style={{  ...mobileStyles, ...style }}>
      {children}
    </InputContainer>
  );
};

SettingsInputContainer.defaultProps = {
  className: '',
  style: {},
};

export default withMobile(SettingsInputContainer);
